import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import CustomButton from '../../../../../../../lib/designSystem/Button';
import { useDispatch } from 'react-redux';
import {
  checkResellReversal,
  revertResell,
} from '../../../../../../../lib/api/funds';
import { showAlert } from '../../../../../../../lib/functions/utils';
import CenteredCircularProgress from '../../../../../../../lib/designSystem/CircularProgress';

const RevertResell = (props: any) => {
  const { open, setOpen, resellToRevert, triggerSearch } = props;
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [canRevert, setCanRevert] = useState(false);
  const [reason, setReason] = useState('');

  const handleRevertResell = async () => {
    setLoading(true);
    try {
      await revertResell(dispatch, { id: resellToRevert });
      showAlert(dispatch, 'success', 'Venta revertida correctamente');
      triggerSearch();
      setOpen(false);
    } catch (error) {
      console.log(error);
      showAlert(dispatch, 'error', 'Error al reversar la venta');
    }
    setLoading(false);
  };

  const fetchIfReversalIsPossible = async () => {
    setLoading(true);
    try {
      const response = await checkResellReversal(dispatch, {
        id: resellToRevert,
      });
      setCanRevert(response.canRevert);
      setReason(response.message);
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchIfReversalIsPossible();
  }, [resellToRevert]);

  return (
    <Dialog open={open} onClose={() => setOpen(false)}>
      <DialogTitle>Revertir la venta a fondo #{resellToRevert}</DialogTitle>
      <DialogContent>
        {loading ? (
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              minHeight: '100px',
            }}
          >
            <CenteredCircularProgress type="dialog" />
          </div>
        ) : (
          <Typography>{reason}</Typography>
        )}
      </DialogContent>
      <DialogActions>
        <CustomButton color="secondary" onClick={() => setOpen(false)}>
          Cancelar
        </CustomButton>
        <CustomButton
          color="primary"
          onClick={handleRevertResell}
          disabled={!canRevert}
        >
          Revertir
        </CustomButton>
      </DialogActions>
    </Dialog>
  );
};

export default RevertResell;
